import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { OELockingProfileModel } from "./oe-locking-profile.model";

/**
 *
 */

export interface OEStrategyRefModel {
  refId: string;
  type: CubiqTS.OrderRelationshipType;
}

export class OEStrategyModel {
  public rootRefId: string | null = null; // real root should have null
  public parentRefId: string | null = null;
  public children: OEStrategyRefModel[] = [];
  public siblings: OEStrategyRefModel[] = [];
  public strategyType: CubiqTS.StrategyType = CubiqTS.StrategyType.STANDARD;

  public lockProfile: OELockingProfileModel = new OELockingProfileModel();

  public permissions = {
    allowOco: true,
    allowLoop: true,
    allowIfDone: true,
    allowTimeout: true,
  };

  constructor(oldModel: OEStrategyModel = null) {
    if (oldModel != null) {
      this.strategyType = oldModel.strategyType;
    }
  }

  public get isChild(): boolean {
    return this.parentRefId != null;
  }

  public get isRoot(): boolean {
    return this.rootRefId == null;
  }

  public get isSibling(): boolean {
    return this.siblings.length !== 0;
  }

  public get isRootOnly(): boolean {
    return this.rootRefId == null && this.children.length === 0 && this.siblings.length === 0;
  }
}
